module.exports = __webpack_public_path__ + "static/media/contact.c1e662f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/contact.jpg
// module id = 806
// module chunks = 4